// Operator-configured event color theme helpers.
// Ported from reg-portal src/components/colorThemeHelpers.ts (JS variant).

const HEX_COLOR_RE = /^#([0-9A-Fa-f]{6})$/;

export function isHexColor(value) {
  return typeof value === 'string' && HEX_COLOR_RE.test(value);
}

// Resolve `record.customization.event.config.colorTheme` into the four
// `...Color` fields the preview's `sx` map expects.
//
// - Returns a fresh object every call (never the input).
// - Each value is normalised to lowercase when it passes `isHexColor`,
//   else `undefined`. Missing keys, malformed values, and missing
//   intermediates all become `undefined` — MUI's `sx` drops the keys and
//   the card renders exactly as it did without a theme.
// - Never mutates input. Never throws on non-object input.
export function resolveColorTheme(record) {
  const result = {};
  const ct = record?.customization?.event?.config?.colorTheme;
  for (const key of ['backgroundColor', 'textColor', 'linkButtonColor', 'buttonTextColor']) {
    const v = ct?.[key];
    result[key] = isHexColor(v) ? v.toLowerCase() : undefined;
  }
  return result;
}
